export default "__VITE_ASSET__DFZzQV2S__"